var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-container"},[_c('div',{staticClass:"profile-card"},[_c('avatar',{attrs:{"engineer":_vm.engineer}}),_c('fields',{attrs:{"engineer":_vm.engineer},on:{"shownotifications":_vm.onShowNotifications}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }